var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
/* tslint:disable */
/* eslint:disable */
/**
* @typedef {string} Url
*/
/**
* @typedef {string} GUID
*/
/**
* @typedef {number} DateTime
*/
var dummy;
var defaultConfig = { endpoint: 'new-dash-platform' };
var init = function (webOrMobileLogger) { return function (userConfig) {
    if (userConfig === void 0) { userConfig = {}; }
    var defaults = userConfig.defaults, restOfConfig = __rest(userConfig, ["defaults"]);
    var config = __assign(__assign({}, defaultConfig), restOfConfig);
    var factoryInstance = typeof webOrMobileLogger.factory === 'function' ? webOrMobileLogger.factory(config) : webOrMobileLogger;
    var logger = getLogger(factoryInstance);
    return defaults ? logger.util.updateDefaults(defaults) : logger;
}; };
export var initCustomLogger = function (factoryInstance) { return getLogger(factoryInstance); };
var getLogger = function (biLoggerClientFactoryInstance) {
    return new Logger(biLoggerClientFactoryInstance);
};
var Logger = /** @class */ (function () {
    function Logger(biLoggerClientFactoryInstance) {
        var _this = this;
        this.biLoggerClientFactoryInstance = biLoggerClientFactoryInstance;
        this.util = {
            updateDefaults: function (defaults) {
                _this.biLoggerClientFactoryInstance.updateDefaults(defaults);
                return _this;
            },
            log: function (logParams, context) {
                return _this.bi.log(logParams, context);
            }
        };
        biLoggerClientFactoryInstance
            .updateDefaults({ src: 5 });
        this.bi = biLoggerClientFactoryInstance.logger({ endpoint: 'new-dash-platform' });
    }
    ;
    /**
    * @typedef {Object} dashboardFinishLoadingBasicDashboardWidgetsParams
    * @property {string} hosting - dashboard/editor/onboarding
    * @property {number} loading_time - loading from start loading the page
    * @property {number} loading_time_from_module - loading from start loading home module (564)
    * @property {number} loading_time_from_start - loading from start loading bizmgr (561)
    * @property {GUID} msid - --
    * @property {string} refferal_info - refferal
    * @property {string} sub_view - sub_view
    * @property {string} view - requested view
    **/
    /**
     * Name: dashboard > finish loading basic dashboard widgets. Evid: 1463.
     * Event description: the event is sent once all the basic widgets are loaded in the dashboard (dashboard 3.0). the basic widgets are site-details, sales, setup, suggestions, more than & help-widget..
    
     * hosting - Type: string. Desc: dashboard/editor/onboarding
     *
     * loading_time - Type: numeric. Desc: loading from start loading the page
     *
     * loading_time_from_module - Type: numeric. Desc: loading from start loading home module (564)
     *
     * loading_time_from_start - Type: numeric. Desc: loading from start loading bizmgr (561)
     *
     * msid - Type: guid. Desc: --
     *
     * refferal_info - Type: string. Desc: refferal
     *
     * sub_view - Type: string. Desc: sub_view
     *
     * view - Type: string. Desc: requested view
     * @param {dashboardFinishLoadingBasicDashboardWidgetsParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.dashboardFinishLoadingBasicDashboardWidgets = function (params) {
        return this.bi.log(__assign({ evid: 1463 }, params));
    };
    /**
    * @typedef {Object} activeDashboardDrapAndDropWidgetParams
    * @property {number} duration - how much time it took to complete the action (in millisec)
    * @property {string} from_location - the location which the widget was dragged/added from
    * @property {string} hosting - ma
    * @property {GUID} msid - --
    * @property {string} to_location - the location which the widget was dragged to (0,1,2,3,4....)
    * @property {string} widget_name - the widget that was dragged
    **/
    /**
     * Name: Active Dashboard > Drap and Drop widget. Evid: 1473.
     * Event description: When the user has dropped a widget in the active dashboard.
    
     * duration - Type: numeric. Desc: how much time it took to complete the action (in millisec)
     *
     * from_location - Type: string. Desc: the location which the widget was dragged/added from
     *
     * hosting - Type: string. Desc: ma
     *
     * msid - Type: guid. Desc: --
     *
     * to_location - Type: string. Desc: the location which the widget was dragged to (0,1,2,3,4....)
     *
     * widget_name - Type: string. Desc: the widget that was dragged
     * @param {activeDashboardDrapAndDropWidgetParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.activeDashboardDrapAndDropWidget = function (params) {
        return this.bi.log(__assign({ evid: 1473 }, params));
    };
    /**
    * @typedef {Object} assetViewParams
    * @property {string} asset_campaign_guid - ids to be consistent with premium events
    * @property {string} asset_campaign_id - ids to be consistent with premium events
    * @property {number} asset_location_from_group_list - item location inside the category
    * @property {string} asset_location_on_page - 0,1,2,3 ../hover/bubble (progress bar)
    * @property {string} group_id - id of category in setup widget
    * @property {string} hosting - ADI/MA/editor
    * @property {GUID} item_id - --
    * @property {string} item_mode - skipped , open . complete
    * @property {GUID} msid - site guid
    * @property {string} offering_guid - offer guid
    * @property {string} premium_badge - the item requires upgrade
    * @property {string} promotionAssetType - deprecated
    * @property {string} promotion_asset_type - bizMgrNavigation / video / externalUrl
    * @property {string} visibility_trigger - normal/step_completed/scrolling to view/ arrow
    **/
    /**
     * Name: Biz Manager - dashboard asset shown. Evid: 590.
     * Event description: what's next asset shown.
    
     * asset_campaign_guid - Type: string. Desc: ids to be consistent with premium events
     *
     * asset_campaign_id - Type: string. Desc: ids to be consistent with premium events
     *
     * asset_location_from_group_list - Type: numeric. Desc: item location inside the category
     *
     * asset_location_on_page - Type: string. Desc: 0,1,2,3 ../hover/bubble (progress bar)
     *
     * group_id - Type: string. Desc: id of category in setup widget
     *
     * hosting - Type: string. Desc: ADI/MA/editor
     *
     * item_id - Type: guid. Desc: --
     *
     * item_mode - Type: string. Desc: skipped , open . complete
     *
     * msid - Type: guid. Desc: site guid
     *
     * offering_guid - Type: string. Desc: offer guid
     *
     * premium_badge - Type: string. Desc: the item requires upgrade
     *
     * promotionAssetType - Type: string. Desc: deprecated
     *
     * promotion_asset_type - Type: string. Desc: bizMgrNavigation / video / externalUrl
     *
     * visibility_trigger - Type: string. Desc: normal/step_completed/scrolling to view/ arrow
     * @param {assetViewParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.assetView = function (params) {
        return this.bi.log(__assign({ evid: 590 }, params));
    };
    /**
    * @typedef {Object} analyticsErrorMessageParams
    * @property {string} error_type - type of the error
    * @property {string} hosting - MA/editor/ADI
    * @property {GUID} msid - msid
    * @property {string} widget_name - widget name
    **/
    /**
     * Name: Widget Loaded Error. Evid: 370.
     * Event description: When the user sees an error message on the widgets in the dashboard.
    
     * error_type - Type: string. Desc: type of the error
     *
     * hosting - Type: string. Desc: MA/editor/ADI
     *
     * msid - Type: guid. Desc: msid
     *
     * widget_name - Type: string. Desc: widget name
     * @param {analyticsErrorMessageParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.analyticsErrorMessage = function (params) {
        return this.bi.log(__assign({ evid: 370 }, params));
    };
    /**
    * @typedef {Object} bizManagerShowTooltipParams
    * @property {string} app_ids - all apps in dashboard (array)
    * @property {string} asset_campaign_guid - when whats next then place
    * @property {string} hosting - MA/editor
    * @property {boolean} is_hover - true if tooltip shown upon hover
    * @property {GUID} msid - metasite id
    * @property {string} name - tooltip name
    * @property {string} place - where tooltip was shown (sidebar, rename dialog)
    **/
    /**
     * Name: Biz Manager - show tooltip. Evid: 583.
     * Event description: tooltip is shown.
    
     * app_ids - Type: string. Desc: all apps in dashboard (array)
     *
     * asset_campaign_guid - Type: string. Desc: when whats next then place
     *
     * hosting - Type: string. Desc: MA/editor
     *
     * is_hover - Type: bool. Desc: true if tooltip shown upon hover
     *
     * msid - Type: guid. Desc: metasite id
     *
     * name - Type: string. Desc: tooltip name
     *
     * place - Type: string. Desc: where tooltip was shown (sidebar, rename dialog)
     * @param {bizManagerShowTooltipParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.bizManagerShowTooltip = function (params) {
        return this.bi.log(__assign({ evid: 583 }, params));
    };
    /**
    * @typedef {Object} viewInDashboardParams
    * @property {string} hosting - ma
    * @property {GUID} msid - --
    * @property {string} name - item name
    * @property {string} widget_name - the widget name in dashboard (this field added only in new dashboard)
    **/
    /**
     * Name: dashboard > item shown in dashboard. Evid: 1172.
     * Event description: when a specific item is shown to the user (for example the feature modal step in setup widget).
    
     * hosting - Type: string. Desc: ma
     *
     * msid - Type: guid. Desc: --
     *
     * name - Type: string. Desc: item name
     *
     * widget_name - Type: string. Desc: the widget name in dashboard (this field added only in new dashboard)
     * @param {viewInDashboardParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.viewInDashboard = function (params) {
        return this.bi.log(__assign({ evid: 1172 }, params));
    };
    /**
    * @typedef {Object} assetClickParams
    * @property {GUID} assetCampaignGuid - deprecated
    * @property {string} asset_campaign_guid - ids to be consistent with premium events
    * @property {string} asset_campaign_id - ids to be consistent with premium events
    * @property {number} asset_location_from_group_list - item location inside the category
    * @property {string} bannerLocationOnPage - deprecated
    * @property {string} asset_location_on_page - (0,1,2,3)
    * @property {string} clickType - deprecated
    * @property {string} click_type - close/ click/activate/skip
    * @property {string} group_id - id of category in setup widget
    * @property {string} hosting - ADI/MA/editor
    * @property {GUID} item_id - assets guid
    * @property {GUID} msid - site guid
    * @property {string} offeringGuid - deprecated
    * @property {string} offering_guid - offer guid
    * @property {string} premium_badge - the item requires upgrade
    * @property {string} promotionAssetType - deprecated
    * @property {string} promotion_asset_type - bizMgrNavigation / video / externalUrl
    * @property {string} visibility_trigger - normal/step_completed
    **/
    /**
     * Name: Biz Manager - dashboard asset click. Evid: 591.
     * Event description: what's next asset clicked.
    
     * assetCampaignGuid - Type: guid. Desc: deprecated
     *
     * asset_campaign_guid - Type: string. Desc: ids to be consistent with premium events
     *
     * asset_campaign_id - Type: string. Desc: ids to be consistent with premium events
     *
     * asset_location_from_group_list - Type: numeric. Desc: item location inside the category
     *
     * bannerLocationOnPage - Type: string. Desc: deprecated
     *
     * asset_location_on_page - Type: string. Desc: (0,1,2,3)
     *
     * clickType - Type: string. Desc: deprecated
     *
     * click_type - Type: string. Desc: close/ click/activate/skip
     *
     * group_id - Type: string. Desc: id of category in setup widget
     *
     * hosting - Type: string. Desc: ADI/MA/editor
     *
     * item_id - Type: guid. Desc: assets guid
     *
     * msid - Type: guid. Desc: site guid
     *
     * offeringGuid - Type: string. Desc: deprecated
     *
     * offering_guid - Type: string. Desc: offer guid
     *
     * premium_badge - Type: string. Desc: the item requires upgrade
     *
     * promotionAssetType - Type: string. Desc: deprecated
     *
     * promotion_asset_type - Type: string. Desc: bizMgrNavigation / video / externalUrl
     *
     * visibility_trigger - Type: string. Desc: normal/step_completed
     * @param {assetClickParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.assetClick = function (params) {
        return this.bi.log(__assign({ evid: 591 }, params));
    };
    /**
    * @typedef {Object} dashboardFetchDealerLayoutFailedParams
    * @property {string} dashboard_type - old/new
    * @property {GUID} msid - msid
    * @property {string} type - fallback/cached
    **/
    /**
     * Name: dashboard > fetch dealer layout failed. Evid: 1999.
     * Event description: when fetching from dealer layout is failed.
    
     * dashboard_type - Type: string. Desc: old/new
     *
     * msid - Type: guid. Desc: msid
     *
     * type - Type: string. Desc: fallback/cached
     * @param {dashboardFetchDealerLayoutFailedParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.dashboardFetchDealerLayoutFailed = function (params) {
        return this.bi.log(__assign({ evid: 1999 }, params));
    };
    /**
    * @typedef {Object} clickInDashboardParams
    * @property {string} hosting - ma
    * @property {string} item_status_desc - deprecated
    * @property {GUID} msid - --
    * @property {string} name - the site details' item: Connect Domain, Manage Plan...
    * @property {string} widget_name - the widget name in dashboard (this field added only in new dashboard)
    **/
    /**
     * Name: dashboard > click in dashboard. Evid: 195.
     * Event description: Click on the action in dashboard widgets. (in the beginning this event was only for site details and in the new dashboard we added other clicks in different widgets.).
    
     * hosting - Type: string. Desc: ma
     *
     * item_status_desc - Type: string. Desc: deprecated
     *
     * msid - Type: guid. Desc: --
     *
     * name - Type: string. Desc: the site details' item: Connect Domain, Manage Plan...
     *
     * widget_name - Type: string. Desc: the widget name in dashboard (this field added only in new dashboard)
     * @param {clickInDashboardParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.clickInDashboard = function (params) {
        return this.bi.log(__assign({ evid: 195 }, params));
    };
    /**
    * @typedef {Object} activeDashboardErrorOfDrapAndDropWidgetParams
    * @property {string} from_location - the location which the widget was dragged/added from (right-panel,0,1,2,3,4....)
    * @property {string} hosting - ma
    * @property {GUID} msid - --
    * @property {string} widget_name - the widget that was dragged
    **/
    /**
     * Name: Active Dashboard > Error of Drap and Drop widget. Evid: 1480.
     * Event description: When the  drag and drop of a widget has failed.
    
     * from_location - Type: string. Desc: the location which the widget was dragged/added from (right-panel,0,1,2,3,4....)
     *
     * hosting - Type: string. Desc: ma
     *
     * msid - Type: guid. Desc: --
     *
     * widget_name - Type: string. Desc: the widget that was dragged
     * @param {activeDashboardErrorOfDrapAndDropWidgetParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.activeDashboardErrorOfDrapAndDropWidget = function (params) {
        return this.bi.log(__assign({ evid: 1480 }, params));
    };
    /**
    * @typedef {Object} dashboardPlatformWidgetsLoadedParams
    * @property {string} available_active_dashboard_widgets - list of all widgets of the active dashboard that available to the user (separated by comma)
    * @property {string} available_widgets - list of all widgets that should be loaded to dashboard - not active dashboard
    * @property {string} hosting - hosting
    * @property {GUID} msid - msid
    * @property {string} selected_active_dashboard_widgets - list of all widgets of the active dashboard that selected to the dashboard
    * @property {string} site_phase - Setup, Ready, First Success..
    **/
    /**
     * Name: dashboard platform > Widgets Loaded. Evid: 1183.
     * Event description: a status event that contains which widgets loaded when the dashboard is loaded.
    
     * available_active_dashboard_widgets - Type: string. Desc: list of all widgets of the active dashboard that available to the user (separated by comma)
     *
     * available_widgets - Type: string. Desc: list of all widgets that should be loaded to dashboard - not active dashboard
     *
     * hosting - Type: string. Desc: hosting
     *
     * msid - Type: guid. Desc: msid
     *
     * selected_active_dashboard_widgets - Type: string. Desc: list of all widgets of the active dashboard that selected to the dashboard
     *
     * site_phase - Type: string. Desc: Setup, Ready, First Success..
     * @param {dashboardPlatformWidgetsLoadedParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.dashboardPlatformWidgetsLoaded = function (params) {
        return this.bi.log(__assign({ evid: 1183 }, params));
    };
    /**
    * @typedef {Object} dashboardFinishLoadingLoadingTimeFromStartModuleParams
    * @property {string} hosting - dashboard/editor/onboarding
    * @property {number} loading_time - loading from start loading the page
    * @property {GUID} msid - --
    * @property {string} refferal_info - refferal
    * @property {string} sub_view - sub_view
    * @property {string} view - requested view
    **/
    /**
     * Name: dashboard > finish loading > loading time from start module. Evid: 1215.
     * Event description: event to check the loading time from start loading.
    
     * hosting - Type: string. Desc: dashboard/editor/onboarding
     *
     * loading_time - Type: numeric. Desc: loading from start loading the page
     *
     * msid - Type: guid. Desc: --
     *
     * refferal_info - Type: string. Desc: refferal
     *
     * sub_view - Type: string. Desc: sub_view
     *
     * view - Type: string. Desc: requested view
     * @param {dashboardFinishLoadingLoadingTimeFromStartModuleParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.dashboardFinishLoadingLoadingTimeFromStartModule = function (params) {
        return this.bi.log(__assign({ evid: 1215 }, params));
    };
    /**
    * @typedef {Object} widgetLoadedParams
    * @property {string} hosting - --
    * @property {boolean} is_shown - 1- shown 0 hidden
    * @property {number} loading_time - loading time from start loading the widget
    * @property {number} loading_time_from_start_loading_home - loading time from start loading the home
    * @property {GUID} msid - msid
    * @property {string} widget_name - widget name
    **/
    /**
     * Name: dashboard > Widget loaded. Evid: 299.
     * Event description: widget is shown in dashboard.
    
     * hosting - Type: string. Desc: --
     *
     * is_shown - Type: bool. Desc: 1- shown 0 hidden
     *
     * loading_time - Type: numeric. Desc: loading time from start loading the widget
     *
     * loading_time_from_start_loading_home - Type: numeric. Desc: loading time from start loading the home
     *
     * msid - Type: guid. Desc: msid
     *
     * widget_name - Type: string. Desc: widget name
     * @param {widgetLoadedParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.widgetLoaded = function (params) {
        return this.bi.log(__assign({ evid: 299 }, params));
    };
    /**
    * @typedef {Object} dashboardWidgetSeenParams
    * @property {string} hosting - hosting
    * @property {GUID} msid - msid
    * @property {string} order - the location of the widget in the active dashboard grid (0,1,2,3,...)
    * @property {string} widget_name - widget name
    **/
    /**
     * Name: dashboard > widget seen. Evid: 298.
     * Event description: widget is shown in the dashboard - the event is being sent only when the user sees the widget.
    
     * hosting - Type: string. Desc: hosting
     *
     * msid - Type: guid. Desc: msid
     *
     * order - Type: string. Desc: the location of the widget in the active dashboard grid (0,1,2,3,...)
     *
     * widget_name - Type: string. Desc: widget name
     * @param {dashboardWidgetSeenParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.dashboardWidgetSeen = function (params) {
        return this.bi.log(__assign({ evid: 298 }, params));
    };
    return Logger;
}());
export { Logger };
export default init;
export function getLoggerConf() {
    return {
        src: 5,
        endpoint: 'new-dash-platform'
    };
}
//# sourceMappingURL=index.js.map